<template>
<div class="chapter">
<div class="inner_page">
<p class="chapter-h"><span>NOTE</span></p>
<p class="normal-1">The characters in this story, the first of a group, are all inventions together with the personality of the narrator, and bear no resemblance to living persons. Only the city is real.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_note.vue?1dfe40de